import React from "react";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComment } from "@fortawesome/pro-solid-svg-icons";
import { faCommentDots } from "@fortawesome/pro-regular-svg-icons";

export default function Composing({ className }: { className?: string }) {
  return (
    <span
      className={classNames(
        "fa-layers leading-none chat__composing",
        className,
      )}
    >
      <FontAwesomeIcon icon={faComment} className="text-white" />
      <FontAwesomeIcon icon={faCommentDots} className="text-muted" />
    </span>
  );
}
